import { Form } from '@primevue/forms'
import Aura from '@primevue/themes/aura'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import BadgeDirective from 'primevue/badgedirective'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import Ripple from 'primevue/ripple'
import StyleClass from 'primevue/styleclass'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import App from './App.vue'
import { enableAppInsights } from './core/appInsights/appInsights'
import { container } from './core/ioc/Container'
import RealTimeEventPlugin from './plugins/RealTimeEventPlugin'
import router from './router'
import { serviceContainerModule } from './service/ServicesContainer'

import '@/assets/styles.scss'
import '@fortawesome/fontawesome-free/css/all.css'
import 'leaflet/dist/leaflet.css'
import { createPinia } from 'pinia'
import i18n from './plugins/I18n'

const pinia = createPinia()
pinia.use(piniaPluginPersistedState)

const app = createApp(App)

app.directive('tooltip', Tooltip)
app.directive('badge', BadgeDirective)
app.directive('ripple', Ripple)
app.directive('styleclass', StyleClass)

container.load(serviceContainerModule)
enableAppInsights()
app.use(router)
app.use(pinia)
app.use(VueDOMPurifyHTML)
app.use(i18n)
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      prefix: 'p',
      darkModeSelector: '.app-dark',
      cssLayer: false
    }
  }
})
app.use(ToastService)
app.use(ConfirmationService)
app.component('Form', Form)
app.use(RealTimeEventPlugin)

app.mount('#app')
